// src/utils/reportCompleto.js

import { authFetch } from './authFetch';

/**
 * Recupera il report completo di una lavorazione.
 *
 * Gli elenchi (lavorazioni in corso, terminate) non portano piu' firme,
 * formData e checks: erano il motivo per cui quelle pagine impiegavano
 * un'eternita' o fallivano del tutto sul telefono, visto che ogni riga si
 * trascinava dietro due PNG in base64.
 *
 * Le pagine di dettaglio pero' quei dati li usano, quindi vengono chiesti
 * qui, per la singola lavorazione, nel momento in cui si apre.
 *
 * Se la chiamata non riesce si restituisce l'elemento cosi' com'e': la
 * pagina si aprira' con quello che ha, invece di non aprirsi.
 */
export async function caricaReportCompleto(item) {
  const idLavorazione = item?.workOrder?._id;
  if (!idLavorazione) return item;

  try {
    const risposta = await authFetch(`/api/work/${idLavorazione}/report`);
    if (!risposta?.ok) return item;

    const { report } = await risposta.json();
    if (!report) return item;

    // il workOrder dell'elenco e' gia' popolato: si tiene quello
    return { ...item, ...report, workOrder: item.workOrder };
  } catch (err) {
    console.warn('Non sono riuscito a caricare il report completo:', err);
    return item;
  }
}
